import { Flex } from "antd";
import { SalesByMarketInvoice } from "tm-shared/types";
import { formatDate, formatDateTime } from "tm-shared/utils";

import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";

import { getPaymentFormText } from "../../ByMarket.utils";
import { StyledSBMRaw } from "../../Styled";

export const InvoiceDetails = ({
    invoice,
}: {
    invoice: SalesByMarketInvoice;
}) => (
    <>
        <StyledSBMRaw>
            <Flex vertical gap={8}>
                <SecondaryText>Дата замовлення</SecondaryText>
                <PrimaryText>
                    {formatDateTime(invoice.creationDate)}
                </PrimaryText>
            </Flex>

            <Flex vertical gap={8}>
                <SecondaryText>Дата поставки</SecondaryText>
                <PrimaryText>
                    {formatDate(invoice.shipmentDate, "-")}
                </PrimaryText>
            </Flex>
        </StyledSBMRaw>

        <StyledSBMRaw>
            <Flex vertical gap={8}>
                <SecondaryText>Дата оплати</SecondaryText>
                <PrimaryText>
                    {formatDate(invoice.paymentDate, "-")}
                </PrimaryText>
            </Flex>

            <Flex vertical gap={8}>
                <SecondaryText>Тип оплати</SecondaryText>
                <PrimaryText>
                    {getPaymentFormText(invoice.paymentForm)}
                </PrimaryText>
            </Flex>
        </StyledSBMRaw>
    </>
);
